<template>
  <div class="category-selector">
    <button class="pill main" :class="{ active }" @click="onMainClick">
      {{ mainLabel }}
    </button>

    <transition name="fade">
      <button
        v-if="subcategory && active"
        class="pill sub"
        @click="onSubClick"
      >
        {{ subcategory }}
      </button>
    </transition>
  </div>
</template>

<script>
export default {
    name: 'CategorySelector',
    props: {
        mainLabel: {
            type: String,
            required: true,
        },
        subcategory: {
            type: String,
            default: null,
        },
        active: {
            type: Boolean,
            default: false,
        }
    },
    setup(_, { emit }) {

        const onMainClick = () => emit('main-click');
        const onSubClick = () => emit('sub-click');

        return {
            onMainClick,
            onSubClick,
        };
    },
}
</script>

<style lang="scss" scoped>
.category-selector {
  display: inline-flex;
  align-items: flex-end;
  position: relative;
}

.pill {
  border: none;
  padding: 0.4rem 0.9rem;
  font-weight: 600;
  border-radius: 9999px;
  transition: background-color 0.2s ease;
}

.main {
  background-color: var(--ion-color-medium);
  color: white;
  position: relative;
  z-index: 2;
}

.main.active {
  background-color: #4c8a83;
}

.sub {
  background-color: #24554f;
  color: white;
  padding: 0.30rem 0.9rem 0.30rem 30px;
  margin-left: -20px;
  z-index: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>